import { TrackForm } from 'components/Form/FormWithTracking/components/TrackForm';
import Form from 'components/Form/style/StyledForm';
import { FocusEventHandler, useState } from 'react';
import { WithSpacingProps } from 'style-utils/withStyledProps/withSpacingProps';
import { WithWidthProps } from 'style-utils/withStyledProps/withWidthProps';

export const FormWithTracking = ({
  children,
  onBlur,
  eventType,
  ...formProps
}: {
  children?: React.ReactNode;
  eventType: string;
  fieldsMap?: { [key: string]: string };
  errorsMap?: { [key: string]: string };
} & React.FormHTMLAttributes<HTMLFormElement> &
  WithSpacingProps &
  WithWidthProps) => {
  const [triggerAnalytics, setTriggerAnalytics] = useState<string>('');

  const onBlurHandler: FocusEventHandler<HTMLFormElement> = (e) => {
    if (typeof onBlur === 'function') {
      onBlur(e);
    }
    setTriggerAnalytics(e.target.name);
  };

  return (
    <Form {...formProps} onBlur={onBlurHandler}>
      <TrackForm
        trigger={[triggerAnalytics, setTriggerAnalytics]}
        eventType={eventType}
        fieldsMap={{}}
        errorsMap={{}}
      />
      {children}
    </Form>
  );
};
